"use client"

import { useState } from "react"
import { useMediaQuery } from "@/hooks/useMediaQuery"
import { unlockGameAudio } from "@/lib/game-audio"

interface PlayButtonProps {
  onClick?: () => void
  text?: string
  type?: number
  children?: React.ReactNode
}

export default function PlayButton({
  onClick,
  text,
  type,
  children,
}: PlayButtonProps) {
  const [isClicked, setIsClicked] = useState(false)
  const isMdScreen = useMediaQuery("(min-width: 768px)")
  const buttonText = text || children || "играть"

  const baseRadius = "33px"
  const mdRadius = "55px"

  const styles =
    type === 1
      ? {
          background:
            "linear-gradient(2.18deg, rgba(90, 159, 211, 0.7) -7.97%, rgba(68, 43, 80, 0.7) 18.69%, rgba(29, 43, 80, 0.7) 67.01%, rgba(90, 159, 211, 0.7) 117.15%)",
          backgroundBlendMode: "screen",
          borderRadius: isMdScreen ? mdRadius : baseRadius,
          backdropFilter: "blur(2px)",
          boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.25)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
        }
      : {
          backgroundImage: "url('/img/buttons/bg.png')",
        }

  const handleClick = () => {
    if (isClicked) return

    if (window.navigator.vibrate) {
      window.navigator.vibrate(20)
    }

    unlockGameAudio()
    setIsClicked(true)
    // Trigger zoom-out animation
    setTimeout(() => {
      if (onClick) onClick()
      setIsClicked(false)
      // Optionally reset after navigation? Not needed because page will unmount
    }, 300) // Match animation duration
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`group relative mx-auto flex mt-[26px] h-[60px] w-[194px] text-[18px] md:mt-[42px] md:h-[90px] md:w-[291px] md:text-[30px] items-center justify-center bg-cover bg-center bg-no-repeat font-black lowercase transition-all duration-300 animate__animated animate__pulse animate__infinite animate__slower transform ${isClicked ? "scale-75 opacity-10" : ""}`}
      style={styles}
      disabled={isClicked}
    >
      <img
        src="/img/buttons/bubble.png"
        className="absolute top-[-7px] left-[-4px] w-[27px]"
      />
      {/* Gradient overlay for better contrast */}
      {/* <div className="absolute inset-0 rounded-full bg-gradient-to-b from-black/30 via-transparent to-black/40" /> */}

      {/* Shine effect on hover */}
      {/* <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" /> */}

      {/* Inner glow */}
      {/* <div className="absolute inset-0 rounded-full border border-white/20 shadow-inner" /> */}

      <span className="relative z-10 text-white">{buttonText}</span>
    </button>
  )
}
